export const INSERT_DOC_TASK_SECTION_COMMAND = 'insertDocTaskSectionCommand';
